module.exports = function init_media_kit_single() {

  const single_root = document.querySelector('.single-media_kit');
  if (!single_root) return;

  /** SHARE BUTTONS */
  const show_share = single_root.querySelector('.share a.show-share');
  const share_dialog = single_root.querySelector('.share .share-dialog');
  const close_dialog = single_root.querySelector('.share .share-dialog .close-dialog');
  const copy_button = single_root.querySelector('.share #copy-button');
  const share_link = single_root.querySelector('.share .share-link');
  const link_copied_notice = single_root.querySelector('.share .link-copied-notice');
  const share_email_input = single_root.querySelector('.share #share-email-input');
  const email_button = single_root.querySelector('.share #email-button');

  // show share dialog
  if (show_share && share_dialog) {
    show_share.addEventListener('click', function() {
      share_dialog.style.display = 'block';
    });
  }

  if (close_dialog && share_dialog) {
    close_dialog.addEventListener('click', function() {
      share_dialog.style.display = 'none';
    });
  }

  // copy share link
  if (copy_button && share_link) {
    copy_button.addEventListener('click', function() {

      copy_to_clipboard(share_link.textContent, function(success) {
        if (success && link_copied_notice) {
          link_copied_notice.classList.add('active');
          setTimeout(function() {
            link_copied_notice.classList.remove('active');
          }, 5000);
        }
      });

    });
  }

  // send email share
  if (share_email_input && email_button) {
    share_email_input.addEventListener('keyup', function() {
      const to_email = share_email_input.value;
      const original_href = email_button.getAttribute('href');
      const href_min_mailto = original_href.substring(original_href.indexOf('?') + 1);
      const mailto = 'mailto:' + to_email + '?';
      email_button.setAttribute('href', mailto + href_min_mailto);
    });
  }

  /** SWIPER */
  // eslint-disable-next-line no-undef, no-unused-vars
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: false,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  /** COPY BUTTON */
  const copy_description_btn = single_root.querySelector('#copy-asset-description-btn');
  if (copy_description_btn) {
    copy_description_btn.addEventListener('click', function() {
      const slide = copy_description_btn.closest('.swiper-slide');
      const desc_element = slide.querySelector('.asset-description');
      const text = desc_element.textContent;

      const original_html = copy_description_btn.innerHTML;

      copy_to_clipboard(text, function(success) {
        if (success) {
          copy_description_btn.innerHTML = '<i class="fa-solid fa-check"></i> Copied!';
        } else {
          copy_description_btn.innerHTML = '<i class="fa-solid fa-exclamation-triangle"></i> Failed!';
        }

        setTimeout(() => {
          copy_description_btn.innerHTML = original_html;
        }, 2000);
      });
    });
  }

  function copy_to_clipboard(text, success_callback) {

    // try the modern approach to clipboard copy first
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(text)
        .then(() => {
          if (success_callback) success_callback(true);
        })
        .catch(() => {
          // if modern approach fails, fall back to execCommand
          const success = fallback_copy_exec_command(text);
          if (success_callback) success_callback(success);
        });
    } else {
      // navigator clipboard not available, use fallback immediately
      const success = fallback_copy_exec_command(text);
      if (success_callback) success_callback(success);
    }
  }

  // fallback method using execCommand
  function fallback_copy_exec_command(text) {

    // create temporary element
    const temp_element = document.createElement('textarea');
    temp_element.value = text;
    temp_element.style.position = 'fixed';
    temp_element.style.left = '-9999px';
    temp_element.style.top = '-9999px';
    document.body.appendChild(temp_element);

    // select and copy
    temp_element.focus();
    temp_element.select();

    let successful = false;
    try {
      successful = document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }

    // clean up
    document.body.removeChild(temp_element);
    return successful;
  }

};
